import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '@/lib/seo';

export default function NotFoundPage() {
  useSeo({
    title: 'Page not found',
    description: 'The page you were looking for could not be found.',
    path: '/404',
    robots: 'noindex,nofollow',
  });
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center">
      <div className="text-emerald-600 text-sm font-semibold tracking-wide uppercase">404</div>
      <h1 className="mt-2 text-5xl font-bold text-slate-900">Page not found</h1>
      <p className="mt-4 text-slate-600">We couldn't find what you were looking for. Try one of our calculators instead.</p>
      <Link to="/tools" className="mt-8 inline-flex px-5 py-3 rounded-lg bg-emerald-600 text-white font-semibold hover:bg-emerald-700">Browse tools</Link>
    </div>
  );
}
